export default __webpack_public_path__ + "static/img/watch_clockbg-archive.728a161.png";